<template>
	<bsh-modal 
		titulo="Editar Categoria"
		:name="name">
		<template v-slot:default>
	        <categoria-produto-form
	        	:dados="dados" 
	        	:name="name" 
	        	:errors="errors">
	        </categoria-produto-form>
	    </template>
	    <template v-slot:footer>
        	<button 
				ref="btnRequest"
        		type="button" 
        		class="btn btn-primary" 
        		@click="update">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	export default {
		props: ['dado_id'],
		data(){
			return {
				dados: [],
				name: 'update_categ_produto',
				errors: []
			}
		}, 
		methods: {
			update(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
	            axios.put(this.$url+'/api/adm/categ-produtos/update/'+this.dado_id, (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.$emit('reload')
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	},
        	getDados(){
	            axios.get(this.$url+'/api/adm/categ-produtos/show/'+this.dado_id)
	            .then(response => {
	                this.dados = response.data.data
	            })
			}
		},
		watch: {
			dado_id(){
				this.getDados()
			}
		}
	}
</script>